import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      e.target.reset();
    }, 3000);
  };

  return (
    <div className="contact">
      <div className="section-inner">
        <div className="contact-layout">
          <div className="contact-left">
            <div className="section-label">Contact</div>
            <div className="contact-intro">
              Let's create something<br /><em>unforgettable</em> together.
            </div>
          </div>
          <div className="contact-right">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-field">
                <label>Name</label>
                <input type="text" placeholder="Your name" required />
              </div>
              <div className="form-field">
                <label>Email</label>
                <input type="email" placeholder="your@email.com" required />
              </div>
              <div className="form-field">
                <label>Message</label>
                <textarea placeholder="Tell me about your production…" />
              </div>
              <button
                type="submit"
                className={`btn-submit ${submitted ? 'sent' : ''}`}
              >
                {submitted ? 'Sent ✓' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;